import React from 'react'
import { Link } from 'react-router-dom'

const Hero = (props) => {
  return (
    <div id="hero">
      <div className="left">
        <img src="./img/hero.jpg" alt=""/>
      </div>
      <div className="right">
        <div className="info">
          <h1>Raising Safe, Confident <span>and Happy Kids</span></h1>
          <div className="button-wrapper">
            <a href="https://www.etsy.com/shop/ComfyBebe?ref=l2-shopheader-name" target="_blank" className="button">Visit our online store</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/home/Hero.js